import React, { useState, useEffect } from 'react';
import './countersection.css';

import { FiCamera, FiCheckCircle, FiClock, FiSmile } from 'react-icons/fi';

const CounterSection = () => {
    const counters = [
        { icon: <FiCamera />, label: 'Wedding Shoots', target: 800 },
        { icon: <FiCheckCircle />, label: 'Projects Completed', target: 1000 },
        { icon: <FiClock />, label: 'Years Of Experience', target: 3 },
        { icon: <FiSmile />, label: 'Happy Clients', target: 1000 },
    ];

    const [counts, setCounts] = useState(Array(counters.length).fill(0));

    useEffect(() => {
        const interval = setInterval(() => {
            setCounts(prevCounts => {
                return prevCounts.map((count, index) => {
                    const increment = Math.ceil(counters[index].target / 100);
                    return count + increment > counters[index].target ? counters[index].target : count + increment;
                });
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="counter-section">
            <h2>Lets Numbers Talk | Projects Completed</h2>
            <div className="counter-container">
                {counters.map((counter, index) => (
                    <div key={index} className="counter-item">
                        {React.cloneElement(counter.icon, { style: { fontSize: '48px' } })}
                        <h4>{counts[index]}+</h4>
                        <h6>{counter.label}</h6>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CounterSection;